import api from './client';

export const getTickets = (params) => api.get('/support/tickets', { params }).then(r => r.data);
export const getTicket = (id) => api.get(`/support/tickets/${id}`).then(r => r.data);
export const createTicket = (data) => api.post('/support/tickets', data).then(r => r.data);
export const addTicketMessage = (id, data) => api.post(`/support/tickets/${id}/messages`, data).then(r => r.data);

// Admin
export const getAdminTickets = (params) => api.get('/admin/support/tickets', { params }).then(r => r.data);
export const updateAdminTicket = (id, data) => api.put(`/admin/support/tickets/${id}`, data).then(r => r.data);
export const addAdminTicketMessage = (id, data) => api.post(`/admin/support/tickets/${id}/messages`, data).then(r => r.data);
